/** Trigger a browser download for generated content. */
export function downloadData(
  filename: string,
  data: Blob | Uint8Array | string,
  mimeType = 'application/octet-stream',
): void {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data as BlobPart], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
